<template>
    <div class="Footer">
       <div class="MaxWid FooterHead">
           <div class="FooterTit">欢迎关注</div>
           <div class="FooterDis">
               <div class="FooterItem" v-for="item in Data" :key="item.id">
                   <div class="FooterItemCode">
                       <img :src="$Global.CommImgHttp+item.url" alt="">
                   </div>
                   <div class="FooterItemCont">
                       <div class="FooterItemTxt">{{item.name}}</div>
                       <div class="FooterItemTxt">{{item.second_name}}</div>
                       <div class="FooterItemTxt">{{item.three_name}}</div>
                   </div>
               </div>
           </div>
       </div> 
       <div class="FooterInfo">
           <div>您是第2822685访问者</div>
           <div>Copyright©2014-2424 中国心理卫生协会版权所有</div>
           <div>京ICP备 14008415号</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                Data:"",
                CodeData:[
                    {url:require('@/assets/img/footer/wx.png'),tit:"中国心理卫生协会",type:"微信公众号",msg:"微信扫描"},
                    {url:require('@/assets/img/footer/kxpj.png'),tit:"中国心理卫生协会",type:"科学普及公众号",msg:"微信扫描"},
                    {url:require('@/assets/img/footer/jxjy.png'),tit:"中国心理卫生协会",type:"继续教育公众号",msg:"微信扫描"},
                    {url:require('@/assets/img/footer/dy.png'),tit:"中国心理卫生协会",type:"抖音号",msg:"抖音扫描"},
                    {url:require('@/assets/img/footer/wb.png'),tit:"中国心理卫生协会",type:"微博账号",msg:"微博扫描"},
                    {url:require('@/assets/img/footer/xhs.png'),tit:"中国心理卫生协会",type:"小红书号",msg:"小红书扫描"}
                ]
            }
        },
        created() {
            this.GetData();
        },
        methods: {
            GetData() {
                this.$get("api/index/bottomList").then(res => {
                    if(res.data.code == 1){
                        this.Data = res.data.data;
                    }
                    
                })
            },
        },
    }
</script>

<style scoped>
    .MaxWid{
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .Footer{
        padding: 20px 0;
        background-color: #0678da;
    }
    .FooterHead{
        padding-bottom: 50px;
    }
    .FooterTit{
        color: #fff;
        font-size: 16px;
        padding-bottom: 20px;
    }
    .FooterDis{
        display: flex;
        align-items: center;
        gap: 1rem;
        flex-wrap: wrap;
    }
    .FooterItem{
        width: 180px;
        display: flex;
        align-items: center;
    }
    .FooterItemCode{
        width: 74px;
        margin-right: 10px;
    }
    .FooterItemTxt{
        color: #fff;
        padding-bottom: 5px;
        font-size: 12px;
    }
    .FooterInfo{
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 40px;
        border-top: 1px solid #0385EB ;
        padding-top: 15px;
        text-align: center;
        color: #fff;
    }
</style> 